var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox-group',{staticClass:"grid-checkbox-group",attrs:{"options":_vm.options,"rowIndx":_vm.rowIndex},on:{"change":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }